import React, { useEffect, useState } from "react";

import { RootStateOrAny, useSelector } from "react-redux";
import * as dateFns from "date-fns";
import { ptBR } from "date-fns/locale";
import {
  Autocomplete,
  Paper,
  createTheme,
  ThemeProvider,
  AutocompleteRenderInputParams,
} from "@mui/material";
import { RiFileExcel2Fill } from "react-icons/ri";

import { AuthState } from "store/ducks/auth/types";
import { usePlantaoVendas } from "contexts/PlantaoVendasContext";
import { converterObjetoParaString } from "hooks/convertObjectToString";
import { useGerarRelatorioRecepcao } from "services/api/AppWeb_Atendimento/relatorio-recepcao";

import MaterialUI from "../../../../../../material-UI";
import * as IconsSVG from "../../../../../../assets/iconsSVG";
import * as S from "./styles";

const height = 40;
const CustomPaper = (props: any) => {
  return <Paper sx={{ marginTop: 0, borderRadius: 0.5 }} {...props} />;
};

const theme = createTheme({
  shape: {
    borderRadius: 8,
  },
});

const SupervisorContent: React.FC = () => {
  const { plantaoVendas, codigoCargo2013, supervisorProduto } = useSelector<
    RootStateOrAny,
    AuthState
  >((state) => state.user);
  const codigosSupervisor = ["219.840.000", "219.840.005"];
  const supervisor = codigosSupervisor.includes(codigoCargo2013 || "");
  const [dateFrom, setDateFrom] = useState<any>(null);
  const [dateTo, setDateTo] = useState<any>(null);
  const {
    plantaoVendasData,
    plantaoVendas: pdvSelected,
    setPlantaoVendas,
  } = usePlantaoVendas();

  const {
    data: dataGerarRelatorioRecepcao,
    refetch: refetchGerarRelatorioRecepcao,
    isFetching: isLoadingGerarRelatorioRecepcao,
    isFetched,
    isSuccess,
    isRefetching,
  } = useGerarRelatorioRecepcao({
    queryKey: "antendimentos",
    params: converterObjetoParaString({
      IdPdv: pdvSelected?.value,
      DataInicio:
        dateFrom && dateFns.isValid(dateFrom)
          ? dateFns.format(dateFrom, "yyyy-MM-dd")
          : null,
      DataFim:
        dateTo && dateFns.isValid(dateTo)
          ? dateFns.format(dateTo, "yyyy-MM-dd")
          : null,
    }),
  });

  const handlePDVChange = (event: any, value: any) => {
    setPlantaoVendas(value);
  };

  return (
    <S.Container>
      {!supervisorProduto && (
        <>
          <S.RoletaButton
            onClick={() => {
              window.location.href = "/roleta";
            }}
          >
            <IconsSVG.RoletaIcon color="#2d5bff" width="30" height="30" />
            <p>Roleta</p>
          </S.RoletaButton>
          <S.Divider />
        </>
      )}
      <S.Column>
        <S.InputLable>Escolha o PDV</S.InputLable>
        <ThemeProvider theme={theme}>
          <Autocomplete
            sx={{
              backgroundColor: "#fff",
              border: "none",
              borderRadius: "8px",
              width: 200,
            }}
            options={
              plantaoVendasData?.map((item: any) => ({
                label: item.nome,
                value: item.idPdv,
                idEmpreendimento: item.idEmpreendimento,
                nomeEmpreendimento: item.nomeEmpreendimento,
              })) || []
            }
            value={pdvSelected}
            onChange={handlePDVChange}
            getOptionLabel={(option: any) => option.label || ""}
            autoHighlight
            size="small"
            fullWidth
            PaperComponent={CustomPaper}
            isOptionEqualToValue={(option: any, value: any) =>
              option?.value === value?.value
            }
            renderInput={(params: AutocompleteRenderInputParams) => (
              <S.CustomTextField {...params} placeholder="" />
            )}
          />
        </ThemeProvider>
      </S.Column>
      <S.Divider />
      <S.Row>
        <S.LocalizationProvider
          locale={ptBR}
          dateAdapter={MaterialUI.AdapterDateFns}
        >
          <S.Column>
            <S.DesktopDatePicker
              inputFormat="dd/MM/yyyy"
              value={dateFrom}
              maxDate={new Date()}
              components={{
                OpenPickerIcon: IconsSVG.CalendarIcon,
              }}
              InputAdornmentProps={{ position: "start" }}
              onChange={(newValue: any) => setDateFrom(newValue)}
              renderInput={(params: any) => (
                <>
                  <S.InputLable>Período</S.InputLable>
                  <S.TextField
                    size="small"
                    InputLabelProps={{ shrink: false }}
                    variant="outlined"
                    {...params}
                    label="Data *"
                    fullWidth
                  />
                </>
              )}
            />
          </S.Column>
          <S.ColumnAlign>
            <S.InputLable>até</S.InputLable>
          </S.ColumnAlign>
          <S.Column>
            <S.DesktopDatePicker
              inputFormat="dd/MM/yyyy"
              value={dateTo}
              components={{
                OpenPickerIcon: IconsSVG.CalendarIcon,
              }}
              minDate={dateFrom}
              maxDate={new Date()}
              InputAdornmentProps={{ position: "start" }}
              onChange={(newValue: any) => setDateTo(newValue)}
              renderInput={(params: any) => (
                <>
                  <S.Space space={26} />
                  <S.TextField
                    size="small"
                    InputLabelProps={{ shrink: false }}
                    variant="outlined"
                    {...params}
                    label="Data *"
                    fullWidth
                  />
                </>
              )}
            />
          </S.Column>
        </S.LocalizationProvider>
        <S.SpaceX space={12} />
        <S.Column>
          <div style={{ height: 24 }} />
          <S.GerarRelatorioButton
            onClick={() => refetchGerarRelatorioRecepcao()}
            disabled={!pdvSelected?.value}
          >
            <RiFileExcel2Fill color="#4CAF50" width="30" height="30" />
            <p>Gerar Relatório de visita</p>
          </S.GerarRelatorioButton>
        </S.Column>
      </S.Row>
    </S.Container>
  );
};

export default SupervisorContent;
